/**
 * Gradatim logo.
 *  - variant 'light' (over DARK backgrounds): uses dark-mode SVG (wordmark in white, tagline in slate-300) — no pill backdrop.
 *  - variant 'dark'  (over LIGHT backgrounds): uses original full-color SVG.
 *  - size: 'sm' (nav) | 'md' | 'lg' (hero).
 */
export const Logo = ({ variant = "light", size = "sm" }) => {
  const onDark = variant === "light";
  const src = onDark ? "/gradatim-logo-dark.svg" : "/gradatim-logo.svg";

  const sizes = {
    sm: "h-10 md:h-11",
    md: "h-14 md:h-16",
    lg: "h-20 md:h-24",
  };

  return (
    <span
      className="inline-flex items-center"
      data-testid="gradatim-logo"
      aria-label="Gradatim — Insurance & Banking System, Community Analytics"
    >
      <img
        src={src}
        alt="Gradatim"
        className={`${sizes[size]} w-auto block`}
        draggable={false}
      />
    </span>
  );
};
